import { service } from '@/lib/request';
import { request } from '../../utils/request';

export function bindCard(cardInfo) {
  return request('/v1/user/bind-card', cardInfo);
}

export function checkCard(cardInfo) {
  return request('/v1/user/check-card', cardInfo);
}

/**
 * 获取福利卡
 */
export function getCards(params) {
  return request('/v1/uc/myCard', params);
}

export function getCardDetail(cardId) {
  return request('/v1/uc/cardDetail', {
    card_id: cardId
  });
}

/**
 * 卡券使用记录（对齐 h5 lib/request 的 uc/cardUseRecord）
 * @param {Object} params { card_id, is_more: 0 只取近一年 / 1 取全部 }
 */
export function getCardUseRecord(params) {
  return request('/v1/uc/cardUseRecord', params);
}

/**
 * 获取核销卡
 */
export function getCheckCards(params) {
  return request('/v1/cancel/user-card', params);
}

export const getCheckCardDetail = (cardId, channelId) => {
  return request(`/v1/cancel/user-card-${cardId}`, {
    channel_id: channelId
  });
};

// 凭领取号卡券
export const card_receive = params => {
  return new Promise((resolve, reject) => {
    service
      .post(`/v1/card/receive`, params)
      .then((res = {}) => {
        const { header = {}, body = {} } = res;
        const { code, action } = header;
        if (+code === 0 || action == 'jump') {
          resolve(body);
        } else {
          reject(res);
        }
      })
      .catch(err => reject(err));
  });
};

// 定制平台是否存在待绑定卡券
export const customConfig = params => {
  return request(`/v2/custom/config`, params);
};

// 通过待绑定卡券类型，获取待绑定卡券信息
export const cardReceiveList = params => {
  return request(`/v1/card/receive/list`, params);
};
